(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-cata"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-story-cata]');
  if (!root) return;

  const thumbs = [...root.querySelectorAll('[data-story-thumb]')];
  const overlay = root.querySelector('.story-cata__overlay');
  const img = overlay.querySelector('.story-cata__img');
  const textEl = overlay.querySelector('.story-cata__text');
  const btnEl = overlay.querySelector('.story-cata__btn');
  const bar = overlay.querySelector('.story-cata__bar');
  const closeEls = overlay.querySelectorAll('[data-story-close]');
  const prev = overlay.querySelector('[data-story-prev]');
  const next = overlay.querySelector('[data-story-next]');
  const duration = Number(root.dataset.autoplayMs || 10000);

  const stories = thumbs.map(t =>
    JSON.parse(t.querySelector('template[data-story-payload]').innerHTML)
  );

  let i = 0;
  let raf = null;
  let startedAt = 0;

  function render(){
    const s = stories[i];
    img.src = s.image || '';

    if (s.hasText){
      textEl.textContent = s.text;
      textEl.style.display = 'block';
      textEl.style.color = s.textColor;
    } else {
      textEl.style.display = 'none';
    }

    if (s.hasButton){
      btnEl.textContent = s.buttonLabel;
      btnEl.href = s.buttonHref;
      btnEl.style.display = 'inline-flex';
      btnEl.style.background = s.buttonBg;
      btnEl.style.color = s.buttonText;
    } else {
      btnEl.style.display = 'none';
    }

    bar.style.width = '0%';
  }

  function tick(){
    const p = Math.min(1,(performance.now()-startedAt)/duration);
    bar.style.width = (p*100)+'%';
    if (p>=1) goNext();
    else raf=requestAnimationFrame(tick);
  }

  function start(){
    cancelAnimationFrame(raf);
    startedAt = performance.now();
    raf = requestAnimationFrame(tick);
  }

  function open(n){
    i=n;
    render();
    overlay.hidden=false;
    start();
  }

  function close(){
    overlay.hidden=true;
    cancelAnimationFrame(raf);
  }

  function goNext(){
    i=(i+1)%stories.length;
    render();
    start();
  }

  function goPrev(){
    i=(i-1+stories.length)%stories.length;
    render();
    start();
  }

  thumbs.forEach(t=>t.addEventListener('click',()=>open(+t.dataset.storyIndex)));
  closeEls.forEach(c=>c.addEventListener('click',close));
  next.addEventListener('click',goNext);
  prev.addEventListener('click',goPrev);
})();

  } catch(e) { console.error(e); }
})();
})();
